// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__14UoI","info":"Note_info__2k5l7","note":"Note_note__2Zppv","actions":"Note_actions__esWWC"};